/* eslint-disable */
// @ts-nocheck
import * as React from "react";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { css } from "styled-components";
import TextField from "@insite/mobius/TextField";
import TextArea from "@insite/mobius/TextArea";
import DatePicker, { DatePickerPresentationProps, DatePickerState } from "@insite/mobius/DatePicker";
import Select, { SelectPresentationProps, SelectProps } from "@insite/mobius/Select";
import Radio, { RadioProps, RadioStyle } from "@insite/mobius/Radio";
import RadioGroup from "@insite/mobius/RadioGroup";
import Checkbox, { CheckboxProps }  from "@insite/mobius/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";
import Typography from "@insite/mobius/Typography";
import translate from "@insite/client-framework/Translate";
import { useEffect, useState } from "react";
import { AddressFieldDisplayCollectionModel, BaseAddressModel, CountryModel, CustomerValidationDto, StateModel } from "@insite/client-framework/Types/ApiModels";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect, ResolveThunks } from "react-redux";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import { TextFieldProps } from "@insite/mobius/TextField";
import FileUpload, { FileUploadPresentationProps } from "@insite/mobius/FileUpload";
import Button from "@insite/mobius/Button";
import Link, { StyledIcon } from "@insite/mobius/Link";
import Printer from '@insite/mobius/Icons/Printer';
import siteMessage from "@insite/client-framework/SiteMessage";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import { ApiParameter, request, post } from "@insite/client-framework/Services/ApiService";
import { ShareEntityModel, TellAFriendModel } from "@insite/client-framework/Types/ApiModels";

export interface RegisterFormStyles {
    container?: InjectableCss;
    registerFormGridItem?: GridItemProps;
    registerFormHeaderGridItem?: GridItemProps;
    listFieldsGridItem?: GridItemProps;
    registerFormRadioGridItem?: GridItemProps;
}

const mapStateToProps = (state: ApplicationState) => ({
    countries: getCurrentCountries(state),
});

const Spacer = () => <div style={{ width: 50 }} />;

const mapDispatchToProps = {
    loadCurrentCountries,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

const fileUploadRef = null;
const taxFileUploadRef = null;
const refrigerantCertRef = null;

const styles: RegisterFormStyles = {
    container: {
        css: css`
            /* stylelint-disable value-no-vendor-prefix */
            display: -ms-grid;
            display: grid;
            padding: 1.5rem 0 0 1.5rem;
            margin: -1.5rem;
            overflow: hidden;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            grid-template-columns: minmax(0, 1fr);
                            -ms-grid-columns: minmax(0, 1fr);
                        `,
                        null,
                        css`
                            grid-template-columns: repeat(2, minmax(0, 1fr));
                            -ms-grid-columns: minmax(0, 1fr) minmax(0, 1fr);
                            grid-template-rows: repeat(5, auto);
                            -ms-grid-rows: auto auto auto auto auto;
                        `,
                        css`
                            grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
                            -ms-grid-columns: minmax(0, 2fr) minmax(0, 1fr);
                        `,
                    ],
                    "min")}
        `,
    },
    registerFormGridItem: {
        width: 6,
    },
    registerFormHeaderGridItem: {
        width: 12,
    },
    listFieldsGridItem: {
        width: 12
    },
    registerFormRadioGridItem: {
        width: 3,
    },
};

interface FormFields {
    selectedBranch: string;
    termsAndConditions: string | React.DetailedReactHTMLElement<{}, HTMLElement> | React.DetailedReactHTMLElement<{}, HTMLElement>[];
    personalGuarantee: string | React.DetailedReactHTMLElement<{}, HTMLElement> | React.DetailedReactHTMLElement<{}, HTMLElement>[];
    privacyPolicy: string | React.DetailedReactHTMLElement<{}, HTMLElement> | React.DetailedReactHTMLElement<{}, HTMLElement>[];
    fairCreditReportingAct: string | React.DetailedReactHTMLElement<{}, HTMLElement> | React.DetailedReactHTMLElement<{}, HTMLElement>[];
    billingStateState: StateModel | undefined;
    signatureStateState: StateModel | undefined;
    businessStateState: StateModel | undefined;
    shipStateState: StateModel | undefined;
    billingState: string | undefined;
    signatureState: string | undefined;
    businessState: string | undefined;
    shipState: string | undefined;
    corpInformation: string;
    referFields: string[];
    tradeReferFields: string[];
    signaturePad: string;
    secondSignaturePad: string;
    referrers: object[];
    tradeReferrers: object[];
    signaturePadOneDateSelected: string;
    signaturePadTwoDateSelected: string;
    epaTechDateSelected: string;
    mailCertificate: boolean;
    termsAndConditionsAgree: boolean;
    privacyPolicyAgree: boolean;
    personalGuaranteeAgree: boolean;
    auerTruck: boolean;
    upsSpeeDee: boolean;
    willCall: boolean;
    pickUp: boolean;
    other: boolean;
    deliverFax: boolean;
    fileUploadRef: string;
    taxFileUploadRef: string;
    refrigerantCertRef: string;
    file: any;
    refrigerantCert: any;
    taxFile: any;
    uploadedLiabilityCertificateFile: any;
    uploadedLiabilityCertificateFileName: string;
    uploadedTaxFile: any;
    uploadedTaxFileFileName: string;
    uploadedRefrigerantCertFile: any;
    uploadedRefrigerantCertFileName: string;
    emailForm: string | undefined;
    billingAndShippingIdentical: string | undefined;
    typeOfBusiness: string | undefined;
    incorrectFileExtension: boolean;
    taxExempt: string;
    submissionOption: string;
    jobNameRequired: string;
    requirePo: string;
    pricesOnPackingSlips: string;
    generalEmail: string;
    invoiceEmail: string;
    statementEmail: string;
    orderAcknowledgment: string;
    backorderNotification: string;
    willCallNotification: string;
    pricingUpdates: string;
    productUpdates: string;
    promotionalUpdates:string;
    serviceUpdates: string;
    creditApplication: string;
    webAccount: string;
    epaTech: string;
    corpInformationExplanation: string;
    federalIdentificationNumber: string;
    taxSsn: string;
    webAccountOpen: string;
    poFormat: string;
    jobNameFormat: string;
    packingBasisAccepted: string;
    authorizedEmployees: string;
    authorizedEmployeeNames: string;
    guarantorSsn: string;
}

interface RegisterFormState {
    formFields: FormFields;
    submissionMessage: string | React.DetailedReactHTMLElement<{}, HTMLElement> | React.DetailedReactHTMLElement<{}, HTMLElement>[];
    states: any[];
    formErrors: {};
    formSubmitAttempted: boolean;
    isSubmitting: boolean;
    formSubmitted: boolean;
    signaturePad: object | null;
    secondSignaturePad: object | null;
    uploadedLiabilityCertificateFile: object | undefined;
    uploadCancelled: boolean;
    isUploading: boolean;
    fileUploadRef: boolean | undefined;
    taxFileUploadRef: boolean | undefined;
    refrigerantCertRef: boolean | undefined;
    allowSubmit: boolean;
    externalResourceLoaded: boolean;
  }

   class RegisterForm extends React.Component<Props, RegisterFormState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            // @ts-ignore
            formFields: {
                selectedBranch: "Madison",
                termsAndConditions: siteMessage("RegisterForm_GeneralTerms"),
                personalGuarantee: siteMessage("RegisterForm_GeneralGuarantee"),
                privacyPolicy: siteMessage("RegisterForm_GeneralPrivacyPolicy"),
                fairCreditReportingAct: siteMessage("RegisterForm_GeneralFairCreditReportingAct"),
                billingState: undefined,
                signatureState: undefined,
                shipState: undefined,
                corpInformation: "Proprietorship",
                referFields: ["block", "none", "none", "none", "none", "none", "none", "none", "none", "none"],
                tradeReferFields: ["block", "none", "none", "none", "none", "none", "none", "none", "none", "none"],
                signaturePad: "",
                secondSignaturePad: "",
                referrers: [],
                tradeReferrers: []
            },
            submissionMessage: siteMessage("RegisterForm_FormSubmitted"),
            states: [],
            formErrors: {},
            formSubmitAttempted: false,
            isSubmitting: false,
            formSubmitted: false,
            signaturePad: null,
            secondSignaturePad: null,
            isUploading: false,
            uploadedLiabilityCertificateFile: undefined,
            uploadCancelled: false,
            fileUploadRef: undefined,
            taxFileUploadRef: undefined,
            refrigerantCertRef: undefined,
            phoneError: "",
            cellError: "",
            faxError: "",
            signaturePhoneError: "",
            bankPhoneError: "",
            bankFaxError: "",
            tradePhone0Error: "",
            tradeFax0Error: "",
            tradePhone1Error: "",
            tradeFax1Error: "",
            tradePhone2Error: "",
            tradeFax2Error: "",
            tradePhone3Error: "",
            tradeFax3Error: "",
            tradePhone4Error: "",
            tradeFax4Error: "",
            tradePhone5Error: "",
            tradeFax5Error: "",
            tradePhone6Error: "",
            tradeFax6Error: "",
            tradePhone7Error: "",
            tradeFax7Error: "",
            tradePhone8Error: "",
            tradeFax8Error: "",
            tradePhone9Error: "",
            tradeFax9Error: "",
            formSubmitterEmailError: "",
            allowSubmit: true,
            webUserPhoneError: "",
            externalResourceLoaded: false,
        };
    }

    handleScroll: any = (event: any) =>
    {
        var scrollHeight = document.getElementById("termsAndConditions").scrollHeight;
        var divHeight = document.getElementById("termsAndConditions")?.clientHeight;
        var scrollerEndPoint = scrollHeight - divHeight;

        var divScrollerTop =  document.getElementById("termsAndConditions")?.scrollTop;
        if(divScrollerTop === scrollerEndPoint)
        {
            this.setState({ allowSubmit: false });
        }
    }

    // @ts-ignore
    submitRegistrationForm: React.FormEvent<HTMLFormElement> = async (event: any) =>  {
        var emailsUrl = "/api/v1/CustomerApplicationForm";
        event.preventDefault();
        var formFields = this.state.formFields;
        // @ts-ignore
        formFields["signaturePad"] = this.state.signaturePad!.toDataURL();
        // @ts-ignore
        formFields["secondSignaturePad"] = this.state.secondSignaturePad!.toDataURL();
        
        formFields["referrers"] = []
        formFields["tradeReferrers"] = []
        formFields["referFields"].forEach(function(field, index) {
            if (field === "block") {
                formFields["referrers"].push({
                    // @ts-ignore
                    "Name": formFields["Name"+index],
                    // @ts-ignore
                    "Title": formFields["Title"+index]
                });
            }
        });
        formFields["tradeReferFields"].forEach(function(field, index) {
            if (field === "block") {
                formFields["tradeReferrers"].push({
                    // @ts-ignore
                    "Name": formFields["TradeReferName"+index],
                    // @ts-ignore
                    "Phone": formFields["TradeReferPhone"+index],
                    // @ts-ignore
                    "Fax": formFields["TradeReferFax"+index],
                    // @ts-ignore
                    "Account": formFields["TradeReferAccount"+index]
                });
            }
        });
        if (formFields["tradeReferrers"].length < 1 || formFields["tradeReferrers"][0]["Name"] == undefined || formFields["tradeReferrers"][0]["Name"].length < 1) {
            formFields["hasTradeReferences"] = "False";
        }
        else {
            console.log(formFields["tradeReferrers"][0]["Name"]);
            formFields["hasTradeReferences"] = "True";
        }
        formFields["tradeReferFields"] = [];
        formFields["referFields"] = [];
        formFields["businessState"] = this.state.formFields.businessStateState?.abbreviation;
        formFields["shipState"] = this.state.formFields.shipStateState?.abbreviation;
        formFields["billingState"] = this.state.formFields.billingStateState?.abbreviation;
        formFields["signatureState"] = this.state.formFields.signatureStateState?.abbreviation;

        formFields["upsSpeeDee"] = formFields["upsSpeeDee"] ? "UPS/SpeeDee" : "";
        formFields["auerTruck"] = formFields["auerTruck"] ? "Auer Truck" : "";
        formFields["willCall"] = formFields["willCall"] ? "Will Call" : "";
        formFields["pickUp"] = formFields["pickUp"] ? "Pick Up" : "";
        formFields["other"] = formFields["other"] ? "Other" : "";
        formFields["deliverFax"] = formFields["deliverFax"] ? "Fax" : "";

        var returnedData = post<any, void>(`${emailsUrl}`, formFields);
        // @ts-ignore
        this.setState({
            formSubmitted: true,
            // @ts-ignore
            formFields: {
                selectedBranch: "Madison",
                termsAndConditions: siteMessage("RegisterForm_GeneralTerms"),
                personalGuarantee: siteMessage("RegisterForm_GeneralGuarantee"),
                privacyPolicy: siteMessage("RegisterForm_GeneralPrivacyPolicy"),
                fairCreditReportingAct: siteMessage("RegisterForm_GeneralFairCreditReportingAct"),
                billingState: undefined,
                signatureState: undefined,
                shipState: undefined,
                corpInformation: "LLC",
                referFields: ["block", "none", "none", "none", "none", "none", "none", "none", "none", "none"],
                tradeReferFields: ["block", "none", "none", "none", "none", "none", "none", "none", "none", "none"],
            },
            submissionMessage: siteMessage("RegisterForm_FormSubmitted"),
            states: [],
            formErrors: {},
            formSubmitAttempted: false,
            isSubmitting: false

        });
        window.scrollTo(0, 0);
        //return request<Result>(`${emailsUrl}`, "POST", { "Content-Type": "application/json" }, formFields);

    };

    handleSignaturePadOneDateChanged: any = (selectedDay: { selectedDay: { toDateString: () => any; }; }) => {
        this.setState({
            formFields: {
                ...this.state.formFields,
                signaturePadOneDateSelected: selectedDay.selectedDay ? selectedDay.selectedDay.toDateString() : undefined,
            },
        });
    };

    handleSignaturePadTwoDateChanged: any = (selectedDay: { selectedDay: { toDateString: () => any; }; }) => {
        this.setState({
            formFields: {
                ...this.state.formFields,
                signaturePadTwoDateSelected: selectedDay.selectedDay ? selectedDay.selectedDay.toDateString() : undefined,
            },
        });
    };

    handleEpaTechDateChanged: any = (selectedDay: { selectedDay: { toDateString: () => any; }; }) => {
        this.setState({
            formFields: {
                ...this.state.formFields,
                epaTechDateSelected: selectedDay.selectedDay ? selectedDay.selectedDay.toDateString() : undefined,
            },
        });
    };

    handleInputChange: TextFieldProps["onChange"] = (event) => {        
        const { target } = event;
        const propertyName = target.name;
        this.setState({
            formFields: {
                ...this.state.formFields,
                [propertyName]: target.value,
            },
        }, () => {
            if (propertyName.includes("Phone") || propertyName.includes("Email") || propertyName.includes("Cell") || propertyName.includes("Fax")) {
                this.validateForm();
            }   
            if (propertyName.includes("CorporationName")) {
                this.setState({
                    formFields: {
                        ...this.state.formFields,
                        // @ts-ignore
                        termsAndConditions: siteMessage("RegisterForm_GeneralTerms").replace("{Company Name}", target.value),
                        personalGuarantee: siteMessage("RegisterForm_GeneralGuarantee").replace("{Company Name}", target.value),
                        fairCreditReportingAct: siteMessage("RegisterForm_GeneralFairCreditReportingAct").replace("{Company Name}", target.value),
                    },
                });
            }         
        });
    };

    handleRadioChange: RadioProps["onChange"] = (event) => {
        const { target } = event;
        // @ts-ignore
        const propertyName = target.name;
        this.setState({
            formFields: {
                ...this.state.formFields,
                // @ts-ignore
                [propertyName]: event.currentTarget.value,
            },
        });
    };

    handleMailCertificateCheckboxChange: CheckboxProps["onChange"] = (_, value) => {
        this.setState({
            formFields: {
                ...this.state.formFields,
                mailCertificate: value,
            },
        });
    };

    handleTermsAndConditionsCheckboxChange: CheckboxProps["onChange"] = (_, value) => {
        this.setState({
            formFields: {
                ...this.state.formFields,
                termsAndConditionsAgree: value,
            },
        });
    };

    handlePrivacyPolicyCheckboxChange: CheckboxProps["onChange"] = (_, value) => {
        this.setState({
            formFields: {
                ...this.state.formFields,
                privacyPolicyAgree: value,
            },
        });
    };

    handlePersonalGuaranteeCheckboxChange: CheckboxProps["onChange"] = (_, value) => {
        this.setState({
            formFields: {
                ...this.state.formFields,
                personalGuaranteeAgree: value,
            },
        });
    };

    handleAuerTruckCheckboxChange: CheckboxProps["onChange"] = (_, value) => {
        this.setState({
            formFields: {
                ...this.state.formFields,
                "auerTruck": value,
            },
        });
    };

    handleUpsCheckboxChange: CheckboxProps["onChange"] = (_, value) => {
        this.setState({
            formFields: {
                ...this.state.formFields,
                "upsSpeeDee": value,
            },
        });
    };

    handleWilLCallCheckboxChange: CheckboxProps["onChange"] = (_, value) => {
        this.setState({
            formFields: {
                ...this.state.formFields,
                "willCall": value,
            },
        });
    };

    handlePickUpCheckboxChange: CheckboxProps["onChange"] = (_, value) => {
        this.setState({
            formFields: {
                ...this.state.formFields,
                "pickUp": value,
            },
        });
    };

    handleOtherCheckboxChange: CheckboxProps["onChange"] = (_, value) => {
        this.setState({
            formFields: {
                ...this.state.formFields,
                "other": value,
            },
        });
    };

    handleFaxCheckboxChange: CheckboxProps["onChange"] = (_, value) => {
        this.setState({
            formFields: {
                ...this.state.formFields,
                "deliverFax": value,
            },
        });
    };

   branchChangeHandler: SelectProps["onChange"] = (event) => {
        const selected = event.target.value;
        
        this.setState({
            formFields: {
                ...this.state.formFields,
                termsAndConditions: siteMessage("RegisterForm_GeneralTerms"),
                personalGuarantee: siteMessage("RegisterForm_GeneralGuarantee"),
                selectedBranch: selected,
                fairCreditReportingAct: siteMessage("RegisterForm_GeneralFairCreditReportingAct")
            },
        });
    };

    corpInformationChangeHandler: SelectProps["onChange"] = (event) => {
        const selected = event.target.value;
        
        this.setState({
            formFields: {
                ...this.state.formFields,
                corpInformation: selected,
            },
        });
    };

    stateChangeHandler: SelectProps["onChange"] = (event) => {
        const selectedState = this.props.countries!.find(c => c.abbreviation === "US")?.states!.find(state => state.id.toString() === event.target.value);
        this.setState({
            formFields: {
                ...this.state.formFields,
                businessStateState: selectedState
            },
        });
    };

    shipStateChangeHandler: SelectProps["onChange"] = (event) => {
        const selectedState = this.props.countries!.find(c => c.abbreviation === "US")?.states!.find(state => state.id.toString() === event.target.value);
        this.setState({
            formFields: {
                ...this.state.formFields,
                shipStateState: selectedState
            },
        });
    };

    billingStateChangeHandler: SelectProps["onChange"] = (event) => {
        const selectedState = this.props.countries!.find(c => c.abbreviation === "US")?.states!.find(state => state.id.toString() === event.target.value);
        this.setState({
            formFields: {
                ...this.state.formFields,
                billingStateState: selectedState
            },
        });
    };

    signatureStateChangeHandler: SelectProps["onChange"] = (event) => {
        const selectedState = this.props.countries!.find(c => c.abbreviation === "US")?.states!.find(state => state.id.toString() === event.target.value);
        this.setState({
            formFields: {
                ...this.state.formFields,
                signatureStateState: selectedState
            },
        });
    };

    // row show/hide

    // @ts-ignore
    rowShowHandler: React.MouseEvent<HTMLButtonElement, MouseEvent> = (event) => {
        event.preventDefault();
        var length = this.state.formFields.referFields.filter(x => x === "block").length;
        // @ts-ignore
        this.setState({            
            formFields: {
                ...this.state.formFields,
                referFields: [
                    ...this.state.formFields.referFields.slice(0,length),
                    "block",
                    ...this.state.formFields.referFields.slice(length+1)
                ]
            }
        });
    };

    // @ts-ignore
    rowHideHandler: React.MouseEvent<HTMLButtonElement, MouseEvent> = () => {
        var length = this.state.formFields.referFields.filter(x => x === "none").length;
        // @ts-ignore
        this.setState({
            formFields: {
                ...this.state.formFields,
                referFields: [
                    ...this.state.formFields.referFields.slice(0,9-length),
                    "none",
                    ...this.state.formFields.referFields.slice(9-length+1)
                ]
            }
        });
    };

    // @ts-ignore
    tradeRowShowHandler: React.MouseEvent<HTMLButtonElement, MouseEvent> = (event) => {
        event.preventDefault();
        var length = this.state.formFields.tradeReferFields.filter(x => x === "block").length;
        // @ts-ignore
        this.setState({
            formFields: {
                ...this.state.formFields,
                tradeReferFields: [
                    ...this.state.formFields.tradeReferFields.slice(0,length),
                    "block",
                    ...this.state.formFields.tradeReferFields.slice(length+1)
                ]
            }
        });
    };

    // @ts-ignore
    tradeRowHideHandler: React.MouseEvent<HTMLButtonElement, MouseEvent> = (event) => {
        var length = this.state.formFields.tradeReferFields.filter(x => x === "none").length;
        // @ts-ignore
        this.setState({
            formFields: {
                ...this.state.formFields,
                    tradeReferFields: [
                    ...this.state.formFields.tradeReferFields.slice(0,9-length),
                    "none",
                    ...this.state.formFields.tradeReferFields.slice(9-length+1)
                ]
            }
        });
    };

    // File upload

    cancelUploadingHandler() {
        this.setState({
                uploadCancelled: true,
                isUploading: false,
                formFields: {
                    ...this.state.formFields,
                    fileUploadRef: "",
                    taxFileUploadRef: "",
                    refrigerantCertRef: "",
                    file: null,
                    taxFile: null
                },
        });

    };

    printApplication() {
        window.print();
    };

    uploadFileHandler() {
        if (this.state.isUploading) {
            return;
        }

        this.setState({
            uploadCancelled: false,

        });

        const reader = new FileReader();
        // @ts-ignore
        reader.onload = onReaderLoad(this.getFileExtension(file.name));
        // @ts-ignore
        reader.readAsArrayBuffer(file);
    };

    onReaderLoad(fileExtension: string) {
        return (e: Event) => {
        };
    };

    onUploadingSuccess() {
        this.setState({
            isUploading: false,
        });
    };

   // @ts-ignore
    getFileExtension: string = (fileName: string) => {
        const splitFileName = fileName.split(".");
        return splitFileName.length > 0 ? splitFileName[splitFileName.length - 1].toLowerCase() : "";
    };

    // @ts-ignore
    fileChangeHandler: React.ChangeEvent<any> = (event: { target: { files: any[]; }; }) => {
        const uploadedFile = event.target.files[0];
        this.setState({
            formFields: {
                ...this.state.formFields,
                uploadedLiabilityCertificateFile: uploadedFile,
                uploadedLiabilityCertificateFileName: uploadedFile?.name
            },

        });
        if (uploadedFile) {
            const promise = new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = function () {
                  resolve(reader.result);
                }
                reader.readAsDataURL(uploadedFile);
              });
            
            promise.then(data => {
                this.setState({
                    formFields: {
                        ...this.state.formFields,
                        uploadedLiabilityCertificateFile: data
                    },
    
                });
            }); 
        }
    };

    // @ts-ignore
    taxFileChangeHandler: React.ChangeEvent<any> = (event: { target: { files: any[]; }; }) => {
        var uploadedFile = event.target.files[0];
        this.setState({
            formFields: {
                ...this.state.formFields,
                uploadedTaxFile: uploadedFile,
                uploadedTaxFileName: uploadedFile?.name,
            },

        });
        if (uploadedFile) {            
            const promise = new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = function () {
                  resolve(reader.result);
                }
                reader.readAsDataURL(uploadedFile);
              });
            
            promise.then(data => {
                this.setState({
                    formFields: {
                        ...this.state.formFields,
                        uploadedTaxFile: data
                    },
    
                });
            });

        }
    };

    // @ts-ignore
    refrigerantCertChangeHandler: React.ChangeEvent<any> = (event: { target: { files: any[]; }; }) => {
        var uploadedFile = event.target.files[0];
        this.setState({
            formFields: {
                ...this.state.formFields,
                uploadedRefrigerantCertFile: uploadedFile,
                uploadedRefrigerantCertFileName: uploadedFile?.name
            },

        });
        if (uploadedFile) {
            const promise = new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = function () {
                  resolve(reader.result);
                }
                reader.readAsDataURL(uploadedFile);
              });
            
            promise.then(data => {
                this.setState({
                    formFields: {
                        ...this.state.formFields,
                        uploadedRefrigerantCertFile: data
                    },
    
                });
            });    
        }
    };

    validateForm = () => {
        let anyErrors = false;
        if (this.state.formFields["FormSubmitterPhone"] != undefined && this.state.formFields["FormSubmitterPhone"].trim().length > 0 && !/^([\(\)/\-\.\+\s]*\d\s?(ext)?[\(\)/\-\.\+\s]*){10,}$/g.test(this.state.formFields["FormSubmitterPhone"])) {
            anyErrors = true;
            this.setState({
                phoneError: siteMessage("RegisterForm_Phone_Validation")   
            }); 
        }
        else if (this.state.formFields["FormSubmitterPhone"] != undefined && this.state.formFields["FormSubmitterPhone"].trim().length > 0)
        {
            this.setState({
                phoneError: ""
            }); 
        }

        if (this.state.formFields["webUserPhone"] != undefined && this.state.formFields["webUserPhone"].trim().length > 0 && !/^([\(\)/\-\.\+\s]*\d\s?(ext)?[\(\)/\-\.\+\s]*){10,}$/g.test(this.state.formFields["webUserPhone"])) {
            anyErrors = true;
            this.setState({
                webUserPhoneError: siteMessage("RegisterForm_Phone_Validation")   
            }); 
        }
        else if (this.state.formFields["webUserPhone"] != undefined && this.state.formFields["webUserPhone"].trim().length > 0)
        {
            this.setState({
                webUserPhoneError: ""
            }); 
        }

        if (this.state.formFields["FormSubmitterCell"] != undefined && this.state.formFields["FormSubmitterCell"].trim().length > 0 && !/^([\(\)/\-\.\+\s]*\d\s?(ext)?[\(\)/\-\.\+\s]*){10,}$/g.test(this.state.formFields["FormSubmitterCell"])) {
            anyErrors = true;
            this.setState({
                cellError: siteMessage("RegisterForm_Phone_Validation")   
            }); 
        }
        else if (this.state.formFields["FormSubmitterCell"] != undefined && this.state.formFields["FormSubmitterCell"].trim().length > 0)
        {
            this.setState({
                cellError: ""
            }); 
        }

        if (this.state.formFields["FormSubmitterFax"] != undefined && this.state.formFields["FormSubmitterFax"].trim().length > 0 && !/^([\(\)/\-\.\+\s]*\d\s?(ext)?[\(\)/\-\.\+\s]*){10,}$/g.test(this.state.formFields["FormSubmitterFax"])) {
            anyErrors = true;
            this.setState({
                faxError: siteMessage("RegisterForm_Phone_Validation")   
            }); 
        }
        else if (this.state.formFields["FormSubmitterFax"] != undefined && this.state.formFields["FormSubmitterFax"].trim().length > 0)
        {
            this.setState({
                faxError: ""
            }); 
        }

        if (this.state.formFields["SignaturePhone"] != undefined && this.state.formFields["SignaturePhone"].trim().length > 0 && !/^([\(\)/\-\.\+\s]*\d\s?(ext)?[\(\)/\-\.\+\s]*){10,}$/g.test(this.state.formFields["SignaturePhone"])) {
            anyErrors = true;
            this.setState({
                signaturePhoneError: siteMessage("RegisterForm_Phone_Validation")   
            }); 
        }
        else if (this.state.formFields["SignaturePhone"] != undefined && this.state.formFields["SignaturePhone"].trim().length > 0)
        {
            this.setState({
                signaturePhoneError: ""
            }); 
        }

        if (this.state.formFields["BankPhone"] != undefined && this.state.formFields["BankPhone"].trim().length > 0 && !/^([\(\)/\-\.\+\s]*\d\s?(ext)?[\(\)/\-\.\+\s]*){10,}$/g.test(this.state.formFields["BankPhone"])) {
            anyErrors = true;
            this.setState({
                bankPhoneError: siteMessage("RegisterForm_Phone_Validation")   
            }); 
        }
        else if (this.state.formFields["BankPhone"] != undefined && this.state.formFields["BankPhone"].trim().length > 0)
        {
            this.setState({
                bankPhoneError: ""
            }); 
        }

        if (this.state.formFields["BankFax"] != undefined && this.state.formFields["BankFax"].trim().length > 0 && !/^([\(\)/\-\.\+\s]*\d\s?(ext)?[\(\)/\-\.\+\s]*){10,}$/g.test(this.state.formFields["BankFax"])) {
            anyErrors = true;
            this.setState({
                bankFaxError: siteMessage("RegisterForm_Fax_Validation")   
            }); 
        }
        else if (this.state.formFields["BankFax"] != undefined && this.state.formFields["BankFax"].trim().length > 0)
        {
            this.setState({
                bankFaxError: ""
            }); 
        }

        if (this.state.formFields["FormSubmitterEmail"] != undefined && this.state.formFields["FormSubmitterEmail"].trim().length > 0 && !/\w+([-+."]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/g.test(this.state.formFields["FormSubmitterEmail"])) {
            anyErrors = true;
            this.setState({
                formSubmitterEmailError: siteMessage("RegisterForm_Email_Validation")   
            }); 
        }
        else if (this.state.formFields["FormSubmitterEmail"] != undefined && this.state.formFields["FormSubmitterEmail"].trim().length > 0 )
        {
            this.setState({
                formSubmitterEmailError: ""
            }); 
        }
        if (this.state.formFields["termsAndConditionsAgree"] == false) {
            anyErrors = true;
        }
        this.setState({
            allowSubmit: anyErrors
        }); 
    };

    componentDidMount() {
        if (!document.getElementById("sigPadScript")) {
            const script = document.createElement("script");
            document.body.appendChild(script);
            script.async = true;
            script.id = "sigPadScript";
            script.onload = this.scriptLoadedFunction;
            script.src = "https://cdn.jsdelivr.net/npm/signature_pad@2.3.2/dist/signature_pad.min.js";
        } else {
            this.scriptLoadedFunction();
        }
    }

    scriptLoadedFunction = () => {
        const canvas = document.querySelectorAll('canvas');
        // @ts-ignore
        var signaturePad = new SignaturePad(canvas[0]);
        // @ts-ignore
        var secondSignaturePad = new SignaturePad(canvas[1]);

        if (!this.props.countries) {
            this.props.loadCurrentCountries();
        }

        var uploads = document.querySelectorAll('FileUpload');
        const fileUploadRef = uploads[0];
        const taxFileUploadRef = uploads[1];
        const refrigerantCertRef = uploads[2];

        this.setState({
            fileUploadRef: true,
            taxFileUploadRef: true,
            refrigerantCertRef: true,
            signaturePad: signaturePad,
            secondSignaturePad: secondSignaturePad,
            externalResourceLoaded: true,
        });
    }

    render() {
        const branches = ["Madison", "Milwaukee", "Sturtevant", "Sheboygan", "Waukesha", "Neenah", "Plymouth", "Fargo"];
        const corpInformationOptions = ["Proprietorship", "Partnership", "LLC", "Corp", "Other"]
    return (
        <StyledWrapper>
            {this.state.formSubmitted && <GridItem {...styles.registerFormHeaderGridItem}>
                        <Typography variant="h6">{this.state.submissionMessage}</Typography>
                    </GridItem>}
            
            {this.state.formSubmitted === false && 
            // @ts-ignore 
            <form id="registerForm" onSubmit={this.submitRegistrationForm}>
            <StyledWrapper>
                <GridContainer>

                <GridItem {...styles.registerFormGridItem}>
                     <Select
                        label={translate("What is your closest Auer Steel branch?")}
                        required
                        placeholder="Select Branch"
                        onChange={this.branchChangeHandler}
                        value={this.state.formFields.selectedBranch}
                    >
                        {branches.map(br => (
                            <option key={br} value={br}>{br}</option>
                        ))}
                    </Select>
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                    <TextField
                        label={translate("Corporation Name")}
                        required
                        name="CorporationName"
                        onChange={this.handleInputChange}
                    />
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                    <TextField
                        label={translate("Doing Business As")}
                        required
                        name="DoingBusinessAs"
                        onChange={this.handleInputChange}
                    />
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                    {(this.props.countries && this.props.countries!.find(c => c.abbreviation === "US") != undefined ) && <Select
                        label={translate("Select state")}
                        required
                        placeholder="Select"
                        onChange={this.stateChangeHandler}
                        value={this.state.formFields.businessStateState?.id || ""}
                    >
                        <option value="">{translate("Select State")}</option>
                        {this.props.countries!.find(c => c.abbreviation === "US")!.states!.map(st => (
                            <option key={st.id} value={st.id}>{st.name}</option>
                        ))}
                    </Select>    }
                </GridItem>
                <GridItem width={[12,12,6,6,6]}>
                        <Select
                            label={translate("Corporation Information")}
                            required
                            name="corpInformation"
                            placeholder="Select Corporation type"
                            onChange={this.corpInformationChangeHandler}
                            value={this.state.formFields.corpInformation}
                        >
                            {corpInformationOptions.map(br => (
                                <option key={br} value={br}>{br}</option>
                            ))}
                        </Select>
                </GridItem>
                <GridItem width={[12,12,6,6,6]}>
                    {this.state.formFields.corpInformation === "Other" && <TextField
                        label={translate("If you selected 'other', please explain: ")}
                        required
                        name="corpInformationExplanation"
                        onChange={this.handleInputChange}
                    />}
                </GridItem>                
                <GridItem {...styles.registerFormGridItem}>
                    <TextField
                        label={translate("County business is located in")}
                        required
                        name="CountyOfBusiness"
                        onChange={this.handleInputChange}
                    />
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                    <TextField
                        label={translate("Full legal name of person submitting form")}
                        required
                        name="FormSubmitterLegalName"
                        onChange={this.handleInputChange}
                    />
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                    <TextField
                        type="phone"
                        label={translate("Phone")}
                        required
                        name="FormSubmitterPhone"
                        onChange={this.handleInputChange}
                        error={this.state.phoneError}
                    />
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                    <TextField
                        type="phone"
                        label={translate("Cell")}
                        required
                        name="FormSubmitterCell"
                        onChange={this.handleInputChange}
                        error={this.state.cellError}
                    />
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                    <TextField
                        type="email"
                        label={translate("Email")}
                        required
                        name="FormSubmitterEmail"
                        onChange={this.handleInputChange}
                        error={this.state.formSubmitterEmailError}
                    />
                </GridItem>                
                </GridContainer>
            </StyledWrapper>
            <StyledWrapper>
                <GridContainer>                    
                    <GridItem {...styles.registerFormGridItem}>
                        <RadioGroup label={translate("Type of business")} name="typeOfBusiness" onChangeHandler={this.handleRadioChange} value={this.state.formFields.typeOfBusiness}>
                            <Radio>HVAC</Radio>
                            <Radio>Plumbing Contractor</Radio>
                            <Radio>Plumbing & Heating Contractor</Radio>
                            <Radio>Mechanical Contractor</Radio>
                            <Radio>Other</Radio>
                        </RadioGroup>                        
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                    {this.state.formFields.typeOfBusiness === "Other" && <TextField
                            label={translate("Enter type of business here: ")}
                            name="typeOfBusinessOther"
                            onChange={this.handleInputChange}
                        />}
                    </GridItem>
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        <Typography variant="h2">{translate("Billing Address")}</Typography>
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                    <TextField
                            label={translate("Address")}
                            required
                            name="BillingAddress1"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                    <TextField
                            label={translate("City")}
                            required
                            name="BillingAddressCity"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                    {(this.props.countries && this.props.countries!.find(c => c.abbreviation === "US") != undefined ) && <Select
                        label={translate("Select state")}
                        required
                        placeholder="Select"
                        onChange={this.billingStateChangeHandler}
                        value={this.state.formFields.billingStateState?.id || ""}
                    >
                        <option value="">{translate("Select State")}</option>
                        {this.props.countries!.find(c => c.abbreviation === "US")?.states!.map(st => (
                            <option key={st.id} value={st.id}>{st.name}</option>
                        ))}
                    </Select>    }
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                    <TextField
                            label={translate("Zip/Postal Code")}
                            required
                            name="BillingAddressPostalCode"
                            onChange={this.handleInputChange}
                        />
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                        <RadioGroup label={translate("Is the billing address the same as the shipping address?")} name="billingAndShippingIdentical" onChangeHandler={this.handleRadioChange} value={this.state.formFields.billingAndShippingIdentical}>
                            <Radio>Yes</Radio>
                            <Radio>No</Radio>
                        </RadioGroup>
                </GridItem>
                {this.state.formFields.billingAndShippingIdentical === "No" &&
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        <Typography variant="h2">{translate("Shipping Address")}</Typography>
                        </GridItem> }
                    {this.state.formFields.billingAndShippingIdentical === "No" && <GridItem {...styles.registerFormGridItem}>
                    <TextField
                            label={translate("Address 1")}
                            required
                            name="ShippingAddress1"
                            onChange={this.handleInputChange}
                        />
                    </GridItem> }
                    {this.state.formFields.billingAndShippingIdentical === "No" && <GridItem {...styles.registerFormGridItem}>
                    <TextField
                            label={translate("City")}
                            required
                            name="ShippingAddressCity"
                            onChange={this.handleInputChange}
                        />
                    </GridItem> }
                    {this.state.formFields.billingAndShippingIdentical === "No" && <GridItem {...styles.registerFormGridItem}>
                    {(this.props.countries && this.props.countries!.find(c => c.abbreviation === "US") != undefined ) && <Select
                        label={translate("Select state")}
                        required
                        placeholder="Select"
                        onChange={this.shipStateChangeHandler}
                        value={this.state.formFields.shipStateState?.id || ""}
                    >
                        <option value="">{translate("Select State")}</option>
                        {this.props.countries!.find(c => c.abbreviation === "US")?.states!.map(st => (
                            <option key={st.id} value={st.id}>{st.name}</option>
                        ))}
                    </Select>    }
                        </GridItem> }
                {this.state.formFields.billingAndShippingIdentical === "No" && <GridItem {...styles.registerFormGridItem}>
                    <TextField
                            label={translate("Zip/Postal Code")}
                            required
                            name="ShippingAddressPostalCode"
                            onChange={this.handleInputChange}
                        />
                </GridItem> }

                <GridItem {...styles.registerFormHeaderGridItem}>
                    <Typography variant="h2">{translate("Principals, officers or owners")}</Typography>
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                        <GridContainer>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.referFields[0]}}>
                                <TextField
                                    label={translate("Name")}
                                    name={"Name0"}
                                    style={{display: this.state.formFields.referFields[0]}}
                                    onChange={this.handleInputChange}
                                />
                                <br/>
                                <TextField
                                    label={translate("Title")}
                                    name={"Title0"}
                                    style={{display: this.state.formFields.referFields[0]}}
                                    onChange={this.handleInputChange}
                                />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.referFields[1]}}>
                                <TextField
                                    label={translate("Name")}
                                    name={"Name1"}
                                    style={{display: this.state.formFields.referFields[1]}}
                                    onChange={this.handleInputChange}
                                />
                                <br/>
                                <TextField
                                    label={translate("Title")}
                                    name={"Title1"}
                                    style={{display: this.state.formFields.referFields[1]}}
                                    onChange={this.handleInputChange}
                                />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.referFields[2]}}>
                                <TextField
                                    label={translate("Name")}
                                    name={"Name2"}
                                    style={{display: this.state.formFields.referFields[2]}}
                                    onChange={this.handleInputChange}
                                />
                                <br/>
                                <TextField
                                    label={translate("Title")}
                                    name={"Title2"}
                                    style={{display: this.state.formFields.referFields[2]}}
                                    onChange={this.handleInputChange}
                                />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.referFields[3]}}>
                                <TextField
                                    label={translate("Name")}
                                    name={"Name3"}
                                    style={{display: this.state.formFields.referFields[3]}}
                                    onChange={this.handleInputChange}
                                />
                                <br/>
                                <TextField
                                    label={translate("Title")}
                                    name={"Title3"}
                                    style={{display: this.state.formFields.referFields[3]}}
                                    onChange={this.handleInputChange}
                                />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.referFields[4]}}>
                                <TextField
                                    label={translate("Name")}
                                    name={"Name4"}
                                    style={{display: this.state.formFields.referFields[4]}}
                                    onChange={this.handleInputChange}
                                />
                                <br/>
                                <TextField
                                    label={translate("Title")}
                                    name={"Title4"}
                                    style={{display: this.state.formFields.referFields[4]}}
                                    onChange={this.handleInputChange}
                                />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.referFields[5]}}>
                                <TextField
                                    label={translate("Name")}
                                    name={"Name5"}
                                    style={{display: this.state.formFields.referFields[5]}}
                                    onChange={this.handleInputChange}
                                />
                                <br/>
                                <TextField
                                    label={translate("Title")}
                                    name={"Title5"}
                                    style={{display: this.state.formFields.referFields[5]}}
                                    onChange={this.handleInputChange}
                                />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.referFields[6]}}>
                                <TextField
                                    label={translate("Name")}
                                    name={"Name6"}
                                    style={{display: this.state.formFields.referFields[6]}}
                                    onChange={this.handleInputChange}
                                />
                                <br/>
                                <TextField
                                    label={translate("Title")}
                                    name={"Title6"}
                                    style={{display: this.state.formFields.referFields[6]}}
                                    onChange={this.handleInputChange}
                                />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.referFields[7]}}>
                                <TextField
                                    label={translate("Name")}
                                    name={"Name7"}
                                    style={{display: this.state.formFields.referFields[7]}}
                                    onChange={this.handleInputChange}
                                />
                                <br/>
                                <TextField
                                    label={translate("Title")}
                                    name={"Title7"}
                                    style={{display: this.state.formFields.referFields[7]}}
                                    onChange={this.handleInputChange}
                                />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.referFields[8]}}>
                                <TextField
                                    label={translate("Name")}
                                    name={"Name8"}
                                    style={{display: this.state.formFields.referFields[8]}}
                                    onChange={this.handleInputChange}
                                />
                                <br/>
                                <TextField
                                    label={translate("Title")}
                                    name={"Title8"}
                                    style={{display: this.state.formFields.referFields[8]}}
                                    onChange={this.handleInputChange}
                                />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.referFields[9]}}>
                                <TextField
                                    label={translate("Name")}
                                    name={"Name9"}
                                    style={{display: this.state.formFields.referFields[9]}}
                                    onChange={this.handleInputChange}
                                />
                                <br/>
                                <TextField
                                    label={translate("Title")}
                                    name={"Title9"}
                                    style={{display: this.state.formFields.referFields[9]}}
                                    onChange={this.handleInputChange}
                                />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem}>
                                {// @ts-ignore
                                }<Button onClick={this.rowShowHandler} type="button" disabled={this.state.formFields.referFields[9] === "block"}>
                                {translate("Add Row")}
                                </Button>
                                <Spacer/>
                                {// @ts-ignore
                                }<Button onClick={this.rowHideHandler} type="button" disabled={this.state.formFields.referFields[0] === "none"}>
                                {translate("Remove Row")}
                                </Button>
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
            <StyledWrapper>
                <GridContainer>
                <GridItem {...styles.registerFormGridItem}>
                        <RadioGroup label={translate("Auer Steel & Heating Supply Co. requires a certificate of business liability insure for all accounts. Please select a submission option below:")} name="submissionOption" onChangeHandler={this.handleRadioChange} value={this.state.formFields.submissionOption}>
                            <Radio>Upload</Radio>
                            <Radio>Email</Radio>
                        </RadioGroup>
                    </GridItem>
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        { (this.state.fileUploadRef && this.state.formFields.submissionOption === "Upload") && <FileUpload
                        // @ts-ignore
                            inputRef={fileUploadRef}
                            fileName={this.state.formFields.file?.name || ""}
                            accept=".png,.jpeg,.jpg,.pdf"
                            label={translate("Upload Liability Certificate")}
                            labelPosition="top"
                            error={this.state.formFields.incorrectFileExtension ? translate("must be .jpg, .jpeg or .png") : undefined}
                            // @ts-ignore
                            onFileChange={this.fileChangeHandler}
                            uid="registerFormFileUpload"
                        />}
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <RadioGroup label={translate("Tax exempt:")} name="taxExempt" required value={this.state.formFields.taxExempt} onChangeHandler={this.handleRadioChange}>
                            <Radio>Yes</Radio>
                            <Radio>No</Radio>
                        </RadioGroup>
                    </GridItem>                    
                    {this.state.formFields.taxExempt === "Yes" && <GridItem {...styles.registerFormGridItem}>
                            <TextField
                            label={translate("Tax exempt #")}
                            name="taxExemptNumber"
                            onChange={this.handleInputChange}
                        />
                        </GridItem> }
                    {this.state.formFields.taxExempt === "Yes" && <GridItem {...styles.registerFormGridItem}>
                        <TextField
                        label={translate("Federal Identification #")}
                        name="federalIdentificationNumber"
                        onChange={this.handleInputChange}
                    />
                    </GridItem> }
                    {this.state.formFields.taxExempt === "Yes" && <GridItem {...styles.registerFormGridItem}>
                        <TextField
                        label={translate("If Proprietorship / Partnership provide SSN")}
                        name="taxSsn"
                        onChange={this.handleInputChange}
                    />
                    </GridItem> }
                    {this.state.formFields.taxExempt === "Yes" && <GridItem {...styles.registerFormHeaderGridItem}>
                    {this.state.taxFileUploadRef &&  <FileUpload
                    // @ts-ignore
                        inputRef={taxFileUploadRef}
                        fileName={this.state.formFields.taxFile?.name || ""}
                        accept=".jpg,.jpeg,.png,.pdf"
                        label={translate("Upload Tax Exempt Status")}
                        labelPosition="top"
                        error={this.state.formFields.incorrectFileExtension ? translate("must be .jpeg, .png or .jpg") : undefined}
                        // @ts-ignore
                        onFileChange={this.taxFileChangeHandler}
                        uid="registerFormFileUploadTax"
                    />}
                    </GridItem>}
                    {this.state.formFields.taxExempt === "Yes" && <GridItem {...styles.registerFormGridItem}>
                        <Typography as="p">{translate("Tax Exempt Certificates:")}</Typography>
                    <Link style={{marginLeft: "10px", marginRight: "10px"}} href="/userfiles/resources/ND Tax Exempt.pdf" target="_blank">{translate("ND")}</Link>
                    <Link style={{marginLeft: "10px", marginRight: "10px"}} href="/userfiles/resources/MI Tax Exempt.pdf" target="_blank">{translate("MI")}</Link>
                    <Link style={{marginLeft: "10px", marginRight: "10px"}} href="/userfiles/resources/WI Tax Exempt.pdf" target="_blank">{translate("WI")}</Link>
                    <Link style={{marginLeft: "10px", marginRight: "10px"}} href="/userfiles/resources/IL Tax Exempt.pdf" target="_blank">{translate("IL")}</Link>
                    <Link style={{marginLeft: "10px", marginRight: "10px"}} href="/userfiles/resources/MN Tax Exempt.pdf" target="_blank">{translate("MN")}</Link>
                        </GridItem> }
                    {this.state.formFields.taxExempt === "Yes" && <GridItem {...styles.registerFormHeaderGridItem}>
                        <Checkbox
                            checked={this.state.formFields.mailCertificate}
                            onChange={this.handleMailCertificateCheckboxChange}
                            // @ts-ignore
                            name="mailCertificate"
                        >
                            {translate("Tax certificate will be mailed rather than uploaded")}
                        </Checkbox>
                    </GridItem>}
                    <GridItem {...styles.registerFormGridItem}>
                        <RadioGroup label={translate("Refrigerant and refrigerant equipment requires a copy of EPA Technician Certificate or Universal Card. Are you EPA Technician Certified or hold a Universal Card?:")} name="epaTech" onChangeHandler={this.handleRadioChange} required value={this.state.formFields.epaTech}>
                            <Radio>EPA Certification</Radio>
                            <Radio>Universal Card</Radio>
                            <Radio>None</Radio>
                        </RadioGroup>
                    </GridItem>
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        { this.state.refrigerantCertRef && (this.state.formFields.epaTech == "EPA Certification" || this.state.formFields.epaTech == "Universal Card") && <FileUpload
                        // @ts-ignore
                            inputRef={refrigerantCertRef}
                            fileName={this.state.formFields.refrigerantCert?.name || ""}
                            accept=".png,.jpeg,.jpg,.pdf"
                            label={translate("Upload Certification Information")}
                            labelPosition="top"
                            error={this.state.formFields.incorrectFileExtension ? translate("must be .jpg, .jpeg, .pdf, or .png") : undefined}
                            // @ts-ignore
                            onFileChange={this.refrigerantCertChangeHandler}
                            required={this.state.formFields.epaTech == "EPA Certification" || this.state.formFields.epaTech == "Universal Card"}
                            uid="registerFormRefrigerantCertFileUpload"
                        />}
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Name")}
                            name="epaTechName"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Certificate #")}
                            name="epaTechCertificateNumber"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
            <StyledWrapper>
                <GridContainer>
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        <TextArea
                                label={translate("Terms & conditions")}
                                // @ts-ignore
                                value={this.state.formFields.termsAndConditions}
                                readOnly
                                rows={12}
                                id="termsAndConditions"
                                onScroll={this.handleScroll}
                            />
                    </GridItem>
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        <Checkbox
                        checked={this.state.formFields.termsAndConditionsAgree}
                        required
                        onChange={this.handleTermsAndConditionsCheckboxChange}
                        // @ts-ignore
                        name="termsAndConditionsAgree">{translate("I agree to all terms and conditions as stated above")}</Checkbox>
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
            <StyledWrapper>
                <GridContainer>
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        <TextArea
                                label={translate("Privacy Policy")}
                                // @ts-ignore
                                value={this.state.formFields.privacyPolicy}
                                readOnly
                                rows={12}
                            />
                    </GridItem>
                    <GridItem {...styles.registerFormHeaderGridItem}>
                    <Checkbox
                        checked={this.state.formFields.privacyPolicyAgree}
                        onChange={this.handlePrivacyPolicyCheckboxChange}
                        // @ts-ignore
                        name="privacyPolicyAgree">{translate("I agree to the privacy policy as stated above")}</Checkbox>
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
            <StyledWrapper>
                <GridContainer>
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        <Typography variant="h2">{translate("Credit Application")}</Typography>
                    </GridItem>
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        <Typography as='p'>{translate("If you would like to purchase product on account with Auer Steel, please select yes and complete the trade references form.")}</Typography>
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <RadioGroup label={translate("Would you like to open a credit account with Auer Steel?")} name="creditApplication" onChangeHandler={this.handleRadioChange} value={this.state.formFields.creditApplication}>
                            <Radio>Yes</Radio>
                            <Radio>No</Radio>
                        </RadioGroup>
                    </GridItem>
                    {this.state.formFields.creditApplication === "Yes" && <GridItem {...styles.registerFormGridItem}>
                    <TextField
                        label={translate("Credit Application Email")}
                        required
                        name="creditAppEmailAddress"
                        onChange={this.handleInputChange}
                    />
                        </GridItem> }
                    {this.state.formFields.creditApplication === "Yes" && <GridItem {...styles.registerFormHeaderGridItem}>
                        <Typography variant="h2">{translate("Bank and Trade References")}</Typography>
                        </GridItem> }
                    {this.state.formFields.creditApplication === "Yes" && <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Requested Credit Line")}
                            required
                            name="RequestedCreditLine"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>}
                    {this.state.formFields.creditApplication === "Yes" && <GridItem {...styles.registerFormHeaderGridItem}>
                        <Typography variant="h2">{translate("Bank Information")}</Typography>
                        </GridItem> }
                    {this.state.formFields.creditApplication === "Yes" && <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Bank Name")}
                            name="BankName"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>}
                    {this.state.formFields.creditApplication === "Yes" &&<GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Bank Address")}
                            name="BankAddress"
                            onChange={this.handleInputChange}
                        />
                    </GridItem> }
                    {this.state.formFields.creditApplication === "Yes" && <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Bank Officer")}
                            name="BankOfficer"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>}
                    {this.state.formFields.creditApplication === "Yes" && <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            type="phone"
                            label={translate("Bank Phone")}
                            name="BankPhone"
                            onChange={this.handleInputChange}
                            error={this.state.bankPhoneError}
                        />
                    </GridItem>}
                    {this.state.formFields.creditApplication === "Yes" && <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            type="phone"
                            label={translate("Bank Fax")}
                            name="BankFax"
                            onChange={this.handleInputChange}
                            error={this.state.bankFaxError}
                        />
                    </GridItem> }
                    {this.state.formFields.creditApplication === "Yes" && <GridItem {...styles.registerFormHeaderGridItem}>
                        <Typography variant="h2">{translate("Trade References")}</Typography>
                    </GridItem>}
                    {this.state.formFields.creditApplication === "Yes" && <GridItem {...styles.registerFormHeaderGridItem}>
                    <Typography variant="h4">{translate("Provide up to three trade references below.")}</Typography>
                    </GridItem> }
                    {this.state.formFields.creditApplication === "Yes" && <GridItem {...styles.registerFormGridItem}>
                        <GridContainer>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.tradeReferFields[0]}}>
                                    <TextField
                                        label={translate("Company Name")}
                                        required
                                        name={"TradeReferName0"}
                                        onChange={this.handleInputChange}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Phone")}
                                        required
                                        name={"TradeReferPhone0"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradePhone0Error}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Fax")}
                                        required
                                        name={"TradeReferFax0"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradeFax0Error}
                                    />
                                    <TextField
                                        label={translate("Account #")}
                                        required
                                        name={"TradeReferAccount0"}
                                        onChange={this.handleInputChange}
                                    />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.tradeReferFields[1]}}>
                                    <TextField
                                        label={translate("Company Name")}
                                        name={"TradeReferName1"}
                                        onChange={this.handleInputChange}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Phone")}
                                        name={"TradeReferPhone1"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradePhone1Error}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Fax")}
                                        name={"TradeReferFax1"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradeFax1Error}
                                    />
                                    <TextField
                                        label={translate("Account #")}
                                        name={"TradeReferAccount1"}
                                        onChange={this.handleInputChange}
                                    />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.tradeReferFields[2]}}>
                                    <TextField
                                        label={translate("Company Name")}
                                        name={"TradeReferName2"}
                                        onChange={this.handleInputChange}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Phone")}
                                        name={"TradeReferPhone2"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradePhone2Error}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Fax")}
                                        name={"TradeReferFax2"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradeFax2Error}
                                    />
                                    <TextField
                                        label={translate("Account #")}
                                        name={"TradeReferAccount2"}
                                        onChange={this.handleInputChange}
                                    />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.tradeReferFields[3]}}>
                                    <TextField
                                        label={translate("Company Name")}
                                        name={"TradeReferName3"}
                                        onChange={this.handleInputChange}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Phone")}
                                        name={"TradeReferPhone3"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradePhone3Error}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Fax")}
                                        name={"TradeReferFax3"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradeFax3Error}
                                    />
                                    <TextField
                                        label={translate("Account #")}
                                        name={"TradeReferAccount3"}
                                        onChange={this.handleInputChange}
                                    />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.tradeReferFields[4]}}>
                                    <TextField
                                        label={translate("Company Name")}
                                        name={"TradeReferName4"}
                                        onChange={this.handleInputChange}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Phone")}
                                        name={"TradeReferPhone4"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradePhone4Error}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Fax")}
                                        name={"TradeReferFax4"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradeFax4Error}
                                    />
                                    <TextField
                                        label={translate("Account #")}
                                        name={"TradeReferAccount4"}
                                        onChange={this.handleInputChange}
                                    />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.tradeReferFields[5]}}>
                                    <TextField
                                        label={translate("Company Name")}
                                        name={"TradeReferName5"}
                                        onChange={this.handleInputChange}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Phone")}
                                        name={"TradeReferPhone5"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradePhone5Error}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Fax")}
                                        name={"TradeReferFax5"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradeFax5Error}
                                    />
                                    <TextField
                                        label={translate("Account #")}
                                        name={"TradeReferAccount5"}
                                        onChange={this.handleInputChange}
                                    />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.tradeReferFields[6]}}>
                                    <TextField
                                        label={translate("Company Name")}
                                        name={"TradeReferName6"}
                                        onChange={this.handleInputChange}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Phone")}
                                        name={"TradeReferPhone6"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradePhone6Error}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Fax")}
                                        name={"TradeReferFax6"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradeFax6Error}
                                    />
                                    <TextField
                                        label={translate("Account #")}
                                        name={"TradeReferAccount6"}
                                        onChange={this.handleInputChange}
                                    />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.tradeReferFields[7]}}>
                                    <TextField
                                        label={translate("Company Name")}
                                        name={"TradeReferName7"}
                                        onChange={this.handleInputChange}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Phone")}
                                        name={"TradeReferPhone7"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradePhone7Error}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Fax")}
                                        name={"TradeReferFax7"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradeFax7Error}
                                    />
                                    <TextField
                                        label={translate("Account #")}
                                        name={"TradeReferAccount7"}
                                        onChange={this.handleInputChange}
                                    />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.tradeReferFields[8]}}>
                                    <TextField
                                        label={translate("Company Name")}
                                        name={"TradeReferName8"}
                                        onChange={this.handleInputChange}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Phone")}
                                        name={"TradeReferPhone8"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradePhone8Error}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Fax")}
                                        name={"TradeReferFax8"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradeFax8Error}
                                    />
                                    <TextField
                                        label={translate("Account #")}
                                        name={"TradeReferAccount8"}
                                        onChange={this.handleInputChange}
                                    />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem} style={{display: this.state.formFields.tradeReferFields[9]}}>
                                    <TextField
                                        label={translate("Company Name")}
                                        name={"TradeReferName9"}
                                        onChange={this.handleInputChange}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Phone")}
                                        name={"TradeReferPhone9"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradePhone9Error}
                                    />
                                    <TextField
                                        type="phone"
                                        label={translate("Fax")}
                                        name={"TradeReferFax9"}
                                        onChange={this.handleInputChange}
                                        error={this.state.tradeFax9Error}
                                    />
                                    <TextField
                                        label={translate("Account #")}
                                        name={"TradeReferAccount9"}
                                        onChange={this.handleInputChange}
                                    />
                            </GridItem>
                            <GridItem {...styles.listFieldsGridItem}>
                                {// @ts-ignore
                                }<Button onClick={this.tradeRowShowHandler} type="button" disabled={this.state.formFields.tradeReferFields[9] === "block"}>
                                {translate("Add Row")}
                                </Button>
                                <Spacer/>
                                {// @ts-ignore
                                }<Button onClick={this.tradeRowHideHandler} type="button" disabled={this.state.formFields.tradeReferFields[0] === "none"}>
                                {translate("Remove Row")}
                                </Button>
                            </GridItem>
                        </GridContainer>
                        </GridItem>}
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        <TextArea
                            // @ts-ignore
                            value={this.state.formFields.fairCreditReportingAct}
                            required
                            readOnly
                            rows={12}
                        />
                    </GridItem>
                    <GridItem {...styles.registerFormHeaderGridItem}><Typography as='p'>{translate("Digital signature:")}</Typography></GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <div className="signature-pad--body" style={{ "border-width":".1em", "border-style": "solid" }}>
                            <canvas width="664" height="266" id="canvas_2"></canvas>
                        </div>
                    </GridItem>
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        <DatePicker
                            label={`${translate("Select Date")}`}
                            onDayChange={this.handleSignaturePadTwoDateChanged}
                        />
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                    <TextField
                        label={translate("Name")}
                        required
                        name="FairCreditName"
                        onChange={this.handleInputChange}
                    />
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Title")}
                            required
                            name="FairCreditTitle"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
            <StyledWrapper>
            <GridContainer>
                <GridItem {...styles.registerFormHeaderGridItem}>
                    <TextArea
                            label={translate("Individual Personal Guaranty")}
                            // @ts-ignore
                            value={this.state.formFields.personalGuarantee}
                            readOnly
                            rows={12}
                        />
                </GridItem>
                <GridItem {...styles.registerFormHeaderGridItem}>
                    <Checkbox
                        checked={this.state.formFields.personalGuaranteeAgree}
                        onChange={this.handlePersonalGuaranteeCheckboxChange}
                        // @ts-ignore
                        name="personalGuaranteeAgree">{translate("I agree to all terms and conditions as stated in this personal guaranty")}</Checkbox>
                </GridItem>
                <GridItem {...styles.registerFormHeaderGridItem}><Typography as='p'>{translate("Digital signature:")}</Typography></GridItem>
                <GridItem {...styles.registerFormGridItem}>
                    <script src="https://cdn.jsdelivr.net/npm/signature_pad@2.3.2/dist/signature_pad.min.js"></script>
                    <div className="signature-pad--body" style={{ "border-width":".1em", "border-style": "solid" }}>
                        <canvas width="664" height="266" id="canvas_1"></canvas>
                    </div>

                </GridItem>
                <GridItem {...styles.registerFormHeaderGridItem}><Typography as='p'>{translate("(Sign as individual, not as an officer of Corporation or LLC)")}</Typography></GridItem>
                <GridItem {...styles.registerFormGridItem}>
                    <DatePicker
                        label={`${translate("Select Date")}`}
                        onDayChange={this.handleSignaturePadOneDateChanged}
                    />
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                <TextField
                    label={translate("Type Name")}
                    name="SignatureTypedName"
                    onChange={this.handleInputChange}
                />
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                    <TextField
                        label={translate("Title")}
                        name="SignatureTitle"
                        onChange={this.handleInputChange}
                    />
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                    <TextField
                        label={translate("Home address")}
                        name="SignatureHomeAddress"
                        onChange={this.handleInputChange}
                    />
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                    <TextField
                        label={translate("City")}
                        name="SignatureCity"
                        onChange={this.handleInputChange}
                    />
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                {(this.props.countries && this.props.countries!.find(c => c.abbreviation === "US") != undefined ) && <Select
                        label={translate("Select state")}
                        placeholder="Select"
                        onChange={this.signatureStateChangeHandler}
                        value={this.state.formFields.signatureStateState?.id || ""}
                    >
                        <option value="">{translate("Select State")}</option>
                        {this.props.countries!.find(c => c.abbreviation === "US")?.states!.map(st => (
                            <option key={st.id} value={st.id}>{st.name}</option>
                        ))}
                    </Select>    }
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                    <TextField
                        label={translate("Zip/Postal Code")}
                        name="SignaturePostalCode"
                        onChange={this.handleInputChange}
                    />
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                    <TextField
                        type="phone"
                        label={translate("Phone")}
                        name="SignaturePhone"
                        onChange={this.handleInputChange}
                        error={this.state.signaturePhoneError}
                    />
                </GridItem>
                <GridItem {...styles.registerFormGridItem}>
                    <TextField
                        label={translate("SSN")}
                        name="guarantorSsn"
                        onChange={this.handleInputChange}
                    />
                </GridItem>
                </GridContainer>
            </StyledWrapper>
            <StyledWrapper>
                <GridContainer>
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        <Typography variant="h2">{translate("Account Preferences")}</Typography>
                    </GridItem>
                    <GridItem {...styles.registerFormRadioGridItem}>
                        <CheckboxGroup label={translate("Typical delivery type")} name="typicalDeliveryType">
                            <Checkbox
                                checked={this.state.formFields.auerTruck}
                                onChange={this.handleAuerTruckCheckboxChange}
                            >
                                {translate("Auer Truck")}
                            </Checkbox>
                            <Checkbox
                                checked={this.state.formFields.upsSpeeDee}
                                onChange={this.handleUpsCheckboxChange}
                            >
                                {translate("UPS/Spee-Dee")}
                            </Checkbox>
                            <Checkbox
                                checked={this.state.formFields.willCall}
                                onChange={this.handleWilLCallCheckboxChange}
                            >
                                {translate("Will-Call")}
                            </Checkbox>
                            <Checkbox
                                checked={this.state.formFields.pickUp}
                                onChange={this.handlePickUpCheckboxChange}
                            >
                                {translate("Pick-Up")}
                            </Checkbox>
                            <Checkbox
                                checked={this.state.formFields.other}
                                onChange={this.handleOtherCheckboxChange}
                            >
                                {translate("Other")}
                            </Checkbox>
                        </CheckboxGroup>
                    </GridItem>
                    <GridItem {...styles.registerFormRadioGridItem}>
                        <RadioGroup label={translate("Does your company require a Job name?")} name="jobNameRequired" onChangeHandler={this.handleRadioChange} value={this.state.formFields.jobNameRequired}>
                            <Radio>Yes</Radio>
                            <Radio>No</Radio>
                        </RadioGroup>
                    </GridItem>
                    {this.state.formFields.jobNameRequired === "Yes" && <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Job name format")}
                            name="jobNameFormat"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>}
                    <GridItem {...styles.registerFormRadioGridItem}>
                        <RadioGroup label={translate("Does your company require a PO?")} name="requirePo" onChangeHandler={this.handleRadioChange} value={this.state.formFields.requirePo}>
                            <Radio>Yes</Radio>
                            <Radio>No</Radio>
                        </RadioGroup>
                    </GridItem>
                    {this.state.formFields.requirePo === "Yes" && <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("PO format")}
                            name="poFormat"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>}
                    <GridItem {...styles.registerFormRadioGridItem}>
                        <RadioGroup label={translate("Do you want prices to print on packing slips?")} name="pricesOnPackingSlips" onChangeHandler={this.handleRadioChange} value={this.state.formFields.pricesOnPackingSlips}>
                            <Radio>Yes</Radio>
                            <Radio>No</Radio>
                        </RadioGroup>
                    </GridItem>
                    <GridItem {...styles.registerFormRadioGridItem}>
                        <RadioGroup label={translate("What packing basis do you accept?")} name="packingBasisAccepted" onChangeHandler={this.handleRadioChange} value={this.state.formFields.packingBasisAccepted}>
                            <Radio>Partial</Radio>
                            <Radio>Order Complete</Radio>
                            <Radio>Partial/Order</Radio>
                            <Radio>Item Complete</Radio>
                            <Radio>Item Partial</Radio>
                            <Radio>Hold</Radio>
                        </RadioGroup>
                    </GridItem>      
                    <GridItem {...styles.registerFormRadioGridItem}>
                        <RadioGroup label={translate("Do you have certain employees authorized to place orders?")} name="authorizedEmployees" onChangeHandler={this.handleRadioChange} value={this.state.formFields.authorizedEmployees}>
                            <Radio>Yes</Radio>
                            <Radio>No</Radio>
                        </RadioGroup>
                    </GridItem>       
                    {this.state.formFields.authorizedEmployees === "Yes" && <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Authorized Employees")}
                            name="authorizedEmployeeNames"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>}       
                    <GridItem {...styles.registerFormRadioGridItem}>
                        <TextField
                                label={translate("Email to send all invoices and statements")}
                                name="invoicesAndStatementsEmail"
                                required
                                onChange={this.handleInputChange}
                            />
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
            <StyledWrapper>
                <GridContainer>                    
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        <Typography as='p'>{translate("Please select yes if you would like to receive the following email notifications. Once you select yes a text box will appear where you can type the email address where the email notification should be sent to. Kindly note that the email address you direct the notification to does not have to be linked to the business account. However, if the person(s) receiving the notification needs access to the business account, please add them to sub accounts in question 10 above.")}</Typography>
                    </GridItem>
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        <Typography variant='h3'>{translate("Account Emails")}</Typography>
                    </GridItem>                    
                    <GridItem {...styles.registerFormGridItem}>
                        <RadioGroup label={translate("Order Acknowledgment")} name="orderAcknowledgment" onChangeHandler={this.handleRadioChange} value={this.state.formFields.orderAcknowledgment}>
                            <Radio>Yes</Radio>
                            <Radio>No</Radio>
                        </RadioGroup>
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Email address(s)")}
                            name="orderAcknowledgmentEmail"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <RadioGroup label={translate("Back Order Notification")} name="backorderNotification" onChangeHandler={this.handleRadioChange} value={this.state.formFields.backorderNotification}>
                            <Radio>Yes</Radio>
                            <Radio>No</Radio>
                        </RadioGroup>
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Email address(s)")}
                            name="backorderNotificationEmail"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <RadioGroup label={translate("Will Call Notification")} name="willCallNotification" onChangeHandler={this.handleRadioChange} value={this.state.formFields.willCallNotification}>
                            <Radio>Yes</Radio>
                            <Radio>No</Radio>
                        </RadioGroup>
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Email address(s)")}
                            name="willCallNotificationEmail"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        <Typography variant='h3'>{translate("Marketing Email")}</Typography>
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <RadioGroup label={translate("Pricing Updates")} name="pricingUpdates" onChangeHandler={this.handleRadioChange} value={this.state.formFields.pricingUpdates}>
                            <Radio>Yes</Radio>
                            <Radio>No</Radio>
                        </RadioGroup>
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Email address(s)")}
                            name="pricingUpdatesEmail"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <RadioGroup label={translate("Product Updates")} name="productUpdates" onChangeHandler={this.handleRadioChange} value={this.state.formFields.productUpdates}>
                            <Radio>Yes</Radio>
                            <Radio>No</Radio>
                        </RadioGroup>
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Email address(s)")}
                            name="productUpdatesEmail"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <RadioGroup label={translate("Promotional Updates")} name="promotionalUpdates" onChangeHandler={this.handleRadioChange} value={this.state.formFields.promotionalUpdates}>
                            <Radio>Yes</Radio>
                            <Radio>No</Radio>
                        </RadioGroup>
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Email address(s)")}
                            name="promotionalUpdatesEmail"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <RadioGroup label={translate("Service Updates")} name="serviceUpdates" onChangeHandler={this.handleRadioChange} value={this.state.formFields.serviceUpdates}>
                            <Radio>Yes</Radio>
                            <Radio>No</Radio>
                        </RadioGroup>
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Email address(s)")}
                            name="serviceUpdatesEmail"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>
                </GridContainer>
            </StyledWrapper>            
            <StyledWrapper>
                <GridContainer>
                    <GridItem {...styles.registerFormHeaderGridItem} style={{paddingBottom: 0}}>
                        <Typography variant="h2">{translate("Web Account")}</Typography>
                    </GridItem>
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        <Typography as='p'>{translate("RegisterForm_WebAccountCopy")}</Typography>
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("First Name")}
                            required
                            name="webUserFirstName"
                            onChange={this.handleInputChange}
                        />
                        
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Last Name")}
                            required
                            name="webUserLastName"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Title")}
                            name="webUserTitle"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Email address (this will be your username)")}
                            required
                            name="webUserEmail"
                            onChange={this.handleInputChange}
                        />
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <TextField
                            label={translate("Phone Number")}
                            required
                            name="webUserPhone"
                            onChange={this.handleInputChange}
                            error={this.state.webUserPhoneError}
                        />
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
            <StyledWrapper>
                <GridContainer>
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        <Typography variant="h2">{translate("Returns Policy")}</Typography>
                    </GridItem>
                    <GridItem {...styles.registerFormHeaderGridItem}>
                        <Typography as='p'>{translate("Original Invoice number and date must be furnished with all returns. Special order items are not subject to return except as approved by manufacturer. Credit for warranty items will be issued only when complete information required by manufacturer is provided. A RESTOCKING CHARGE OF 15% WILL APPLY ON ALL MATERIALS RETURNED AFTER 90 DAYS.")}</Typography>
                    </GridItem>
                    <GridItem width={[12,12,6,6,6]}>
                    <RadioGroup label={translate("Would you like a copy of this form emailed to the email address to the left for your records?")} name="emailForm" value={this.state.formFields.emailForm} onChangeHandler={this.handleRadioChange}>
                        <Radio>Yes</Radio>
                        <Radio>No</Radio>
                    </RadioGroup>
                </GridItem>
                </GridContainer>
            </StyledWrapper>
            <StyledWrapper>
                <GridContainer>
                    <GridItem {...styles.registerFormGridItem}>
                        <Link onClick={this.printApplication}>{translate("Click here to print application prior to submission")} <Icon src={Printer} /></Link>
                    </GridItem>
                    <GridItem {...styles.registerFormGridItem}>
                        <Button disabled={this.state.allowSubmit} type="submit">{translate("Agree to terms & submit form")}</Button>
                    </GridItem>

                </GridContainer>
            </StyledWrapper>
            </form> }
        </StyledWrapper>
    );
}

};

const registerForm: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RegisterForm),
    definition: {
        group: "Common",
        displayName: "Register Form",
    },
};

export default registerForm;
